<script>
  import Input from '@components/Input.svelte';
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';

  export let value;
  export let error;
  export let valid;
  // "validateFn" is expected to be a (potentially async) function that:
  // - takes in a string value with the email input value
  // - returns a custom error message (that will be displayed),
  // or a falsey value if no error.
  //
  // Also NOTE: there is a special case in the HTML below, for a value
  // of 'exists', which renders a special set of components below, to help
  // the user sign into their existing account.
  export let validateFn = async (_emailValue) => {};
  export let validateAfterTyping = false;

  let customError; // 'exists' | 'sameUser'

  const dispatch = createEventDispatcher();

  const validate = async (emailValue) => {
    customError = await validateFn(emailValue);
    valid = !customError;
  };

  let keyupValidateTimer;
  const debounceValidate = () => {
    clearTimeout(keyupValidateTimer);
    keyupValidateTimer = setTimeout(async () => {
      await validate(value);
    }, 500);
  };
</script>

<style style="text/scss" lang="scss">
  .email-error {
    text-align: left;
    color: #dc3545;
    margin-left: 10px;

    a {
      text-decoration: underline !important;
      color: #a71d2a !important;
    }
  }
</style>

<div>
  <Input
    type="email"
    error={customError ? undefined : error}
    bind:value={value}
    {...$$restProps}
    on:click={(e) => {
      dispatch('click', e.detail);
    }}
    on:focus={(e) => {
      dispatch('focus', e.detail);
    }}
    on:keydown={(e) => {
      dispatch('keydown', e.detail);
    }}
    on:keyup={(e) => {
      if (e.detail.which === 13) {
        validate(value);
      } else if (validateAfterTyping) {
        debounceValidate();
      }

      dispatch('keyup', e.detail);
    }}
    on:change={(e) => {
      dispatch('change', e.detail);
    }}
    on:blur={(e) => {
      validate(value);
      dispatch('blur', e.detail);
    }}
    on:mounted={(e) => {
      dispatch('mounted', e.detail);
    }} />

  {#if customError === 'exists'}
    <div class="email-error" transition:fade={{ duration: 100 }}>
      An account with this email already exists.

      <div style="display: flex;">
        <a
          href="#"
          on:click|preventDefault={() => {
            dispatch('sign-in-clicked');
          }}>Sign In</a>
        <span style="margin-left: 10px; margin-right: 10px;">|</span>
        <a
          href="#"
          on:click|preventDefault={() => {
            window.open('/forgot_password');
          }}>Forgot Password</a>
      </div>
    </div>
  {:else if customError}
    <div class="email-error" transition:fade={{ duration: 100 }}>
      {customError}
    </div>
  {/if}
</div>
